<template>
  <section class="flex justify-center items-center">
    <div class="container">
      <div class="alex-intro -m-2 w-5/6 sm:w-full lg:w-5/6 justify-center sm:justify-between">
        <div class="p-3 md:w-2/3 md:text-left">
          <img
            src="../../../../../../src/assets/images/demo/dpd_logo.svg"
            width="220px"
            class="mb-2"
          />
          <p class="text-white text-left">
            MyPath is your personal &nbsp; self-paced learning platform brought to you by DPD. MyPath comes with a friendly chatbot called ALEX – who will appear at many points in your learning journey and take care of training suggestions which might be), podcasts, videos, and articles. You’ll get regular notifications of new releases and all are based on your learning needs (ex: the main DPD competencies you need to develop in your role) and your identified notification preferences (ex: preferred day of the week &nbsp; time of day, preferred language…). Ok, so are you ready to start your learning journey?
          </p>
        </div>
        <div class="lg:-mr-4 text-center md:w-1/3 p-4 flex justify-center">
          <img
            src="../../../../../../src/assets/images/demo/alex-outofbox.png"
            width="290px"

          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "Header",
};
</script>
<style scoped>
section {
  position: relative;
  min-height: 85vh;
  background: url("../../../../../../src/assets/images/demo/dpd_bg.svg") center;
  background-size: cover;
}
.alex-intro {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding-top: 18%;
}
.alex-intro p {
  font-size: 16px;
}
</style>
